import cx from 'classnames'
import s from './love-link.sass'

export default (props) => (
  <a href='https://www.instagram.com/picular.co/' class={cx(s.link, props.class)} target='_blank' rel='noopener noreferrer'>
    <span class={s.underline}>Follow</span> our <img src={require('../images/icon-instagram.svg').default} alt='Instagram logo' width='20' height='20' /> for daily palette inspiration!
  </a>
)
